export const images = {
    logo: {
        path: '../../assets/logo.png',
        name: 'logo.png',
        alt: 'logo'
    },
    bgImages: {
        path: '../../assets/img/city.jpg',
        name: '',
        alt: ''
    }
};

export const person = {
    firstname: 'Filip',
    middlename: '',
    lastname: 'Vanden Eynde',
    subtitle: 'A challenge-loving web developer',
    about: "Hi, my name is John Doe. I\"m just about the most boring type of person you could possibly imagine. " +
        "I like collecting leaves from the tree in my back yard and documenting each time " +
        "I eat a peanut that is non-uniform. " +
        "I am not a robot. Please hire me.",
    position: "Software Developer",
    birthDay: {
        day: "20",
        month: "04",
        year: "1990",
        fullDate: "20/04/1994",
        location: "Ninove",
        country: "Belgium"
    },
    contactinfo: {
        email: "john.doe@email.com",
        phone: "0123 456789",
        website: "johndoe.com",
        location: "Belgium"
    },
    lang: "en"
};

export const socials = [
    {
        provider: 'github',
        icon: '',
        iconFontAwesome: {name: 'github', icon: 'fa-github', type: 'fab', fullname: 'fab fa-github'},
        link: 'filipve1994',
        info: ''
    },
    {
        provider: 'linkedin',
        icon: '',
        iconFontAwesome: {name: 'linkedin', icon: 'fa-linkedin', type: 'fab', fullname: 'fab fa-linkedin'},
        link: '',
        info: ''
    },
    // {
    //   provider: 'twitter',
    //   icon: '',
    //   iconFontAwesome: '',
    //   link: '',
    //   info: ''
    // },
    {
        provider: 'instagram',
        icon: '',
        iconFontAwesome: {name: 'instagram', icon: 'fa-instagram', type: 'fab', fullname: 'fab fa-instagram'},
        link: '',
        info: ''
    },
    // {
    //   provider: '',
    //   icon: '',
    //   link: '',
    //   info: ''
    // },
    // {
    //   provider: '',
    //   icon: '',
    //   link: '',
    //   info: ''
    // },
]

export const experiences = [
    {
        company: "Company A",
        position: "Developer",
        timeperiod: {
            begin: 'since January 2016',
            end: '',
        },
        description: 'Programming and watching cute cat videos.',
        website: 'https://example.com',
    },
    {
        company: "Company B",
        position: "Frontend Developer",
        timeperiod: {
            begin: 'January 2015',
            end: 'December 2015',
        },
        description: 'Fulfillment of extremely important tasks.',
        website: '',
    },
    {
        company: "Company C",
        position: "Trainee",
        timeperiod: {
            begin: 'March 2014',
            end: 'December 2014',
        },
        description: 'aking coffee and baking cookies.',
        website: '',
    },
    {
        company: "Company A",
        position: "Developer",
        timeperiod: {
            begin: 'since January 2016',
            end: '',
        },
        description: 'Programming and watching cute cat videos.',
        website: 'https://example.com',
    },
    {
        company: "Company B",
        position: "Frontend Developer",
        timeperiod: {
            begin: 'January 2015',
            end: 'December 2015',
        },
        description: 'Fulfillment of extremely important tasks.',
        website: '',
    },
    {
        company: "Company C",
        position: "Trainee",
        timeperiod: {
            begin: 'March 2014',
            end: 'December 2014',
        },
        description: 'aking coffee and baking cookies.',
        website: '',
    },
    // {
    //   company: "Company A",
    //   position: "Developer",
    //   timeperiod: {
    //     begin: '',
    //     end: '',
    //   },
    //   description: '',
    //   website: '',
    // },
    // {
    //   company: "Company A",
    //   position: "Developer",
    //   timeperiod: {
    //     begin: '',
    //     end: '',
    //   },
    //   description: '',
    //   website: '',
    // },
    // {
    //   company: "Company A",
    //   position: "Developer",
    //   timeperiod: {
    //     begin: '',
    //     end: '',
    //   },
    //   description: '',
    //   website: '',
    // },
];

export const education = [
    {
        degree: "Master of Arts",
        specialization: "",
        timeperiod: {
            begin: 'March 2012',
            end: 'December 2013',
        },
        description: 'Major in Hacking and Computer Penetration, University A, New York, USA.',
        website: 'https://example.com',
    },
    {
        company: "Bachelor of Science",
        position: "Developer",
        timeperiod: {
            begin: 'March 2009',
            end: 'December 2011',
        },
        description: 'Major in Engineering, University B, Los Angeles, USA.',
        website: '',
    },
    {
        degree: "Master of Arts",
        specialization: "",
        timeperiod: {
            begin: 'March 2012',
            end: 'December 2013',
        },
        description: 'Major in Hacking and Computer Penetration, University A, New York, USA.',
        website: 'https://example.com',
    },
    {
        company: "Bachelor of Science",
        position: "Developer",
        timeperiod: {
            begin: 'March 2009',
            end: 'December 2011',
        },
        description: 'Major in Engineering, University B, Los Angeles, USA.',
        website: '',
    },
    // {
    //   company: "Company A",
    //   position: "Developer",
    //   timeperiod: {
    //     begin: '',
    //     end: '',
    //   },
    //   description: '',
    //   website: '',
    // },
    // {
    //   company: "Company A",
    //   position: "Developer",
    //   timeperiod: {
    //     begin: '',
    //     end: '',
    //   },
    //   description: '',
    //   website: '',
    // },
];

export const skills = [
    {
        name: "HTML5",
        level: "99",
        icon: '',
        iconFontAwesome: {name: 'html5', icon: 'fa-html5', type: 'fab', fullname: 'fab fa-html5'},
        info: ''
    },
    {
        name: "CSS3",
        level: "95",
        icon: '',
        iconFontAwesome: {name: 'css3', icon: 'fa-css3', type: 'fab', fullname: 'fab fa-css3'},
        info: ''
    },
    {
        name: "JavaScript",
        level: "97",
        icon: '',
        iconFontAwesome: {name: 'js', icon: 'fa-js', type: 'fab', fullname: 'fab fa-js'},
        info: ''
    },
    {
        name: "Node.js",
        level: "93",
        icon: '',
        iconFontAwesome: {name: 'node-js', icon: 'fa-node-js', type: 'fab', fullname: 'fab fa-node-js'},
        info: ''
    },
    {
        name: "Angular 2",
        level: "60",
        icon: '',
        iconFontAwesome: {name: 'angular', icon: 'fa-angular', type: 'fab', fullname: 'fab fa-angular'},
        info: ''
    },
    {
        name: "TypeScript",
        level: "80",
        icon: '',
        iconFontAwesome: {name: 'ts', icon: 'fa-ts', type: 'fab', fullname: 'fab fa-ts'},
        info: ''
    },
    {
        name: "Docker",
        level: "99",
        icon: '',
        iconFontAwesome: {name: 'docker', icon: 'fa-docker', type: 'fab', fullname: 'fab fa-docker'},
        info: ''
    },
    // {
    //   name: "",
    //   level: "",
    //   icon: '',
    //   iconFontAwesome: {
    //     "type": "",
    //     "iconname": ""
    //   }
    //   },
    // {
    //   name: "",
    //   level: "",
    //   icon: '',
    //   iconFontAwesome: {
    //     "type": "",
    //     "iconname": ""
    //   }
    //   },
    // {
    //   name: "",
    //   level: "",
    //   icon: '',
    //   iconFontAwesome: {
    //     "type": "",
    //     "iconname": ""
    //   }
    //   },
];

export const knowledge = {
    knowledge: 'Also proficient in Adobe Photoshop and Illustrator, grew up bilingual (English and Klingon).'
}

export const projects = [
    {
        name: "best-resume-ever",
        platform: "Vue",
        timeperiod: 'February 2016',
        description: ' 💼 Build fast 🚀 and easy multiple beautiful resumes and create your best CV ever! Made with Vue and LESS.',
        url: "https://github.com/salomonelli/best-resume-ever"
    },
    {
        name: "best-resume-ever",
        platform: "Vue",
        timeperiod: 'February 2016',
        description: ' 💼 Build fast 🚀 and easy multiple beautiful resumes and create your best CV ever! Made with Vue and LESS.',
        url: "https://github.com/salomonelli/best-resume-ever"
    },
    {
        name: "best-resume-ever",
        platform: "Vue",
        timeperiod: 'February 2016',
        description: ' 💼 Build fast 🚀 and easy multiple beautiful resumes and create your best CV ever! Made with Vue and LESS.',
        url: "https://github.com/salomonelli/best-resume-ever"
    },
    {
        name: "best-resume-ever",
        platform: "Vue",
        timeperiod: 'February 2016',
        description: ' 💼 Build fast 🚀 and easy multiple beautiful resumes and create your best CV ever! Made with Vue and LESS.',
        url: "https://github.com/salomonelli/best-resume-ever"
    },
    {
        name: "best-resume-ever",
        platform: "Vue",
        timeperiod: 'February 2016',
        description: ' 💼 Build fast 🚀 and easy multiple beautiful resumes and create your best CV ever! Made with Vue and LESS.',
        url: "https://github.com/salomonelli/best-resume-ever"
    },
    // {
    //   name: "",
    //   platform: "",
    //   timeperiod: '',
    //   description: '',
    //   url: ""
    // },
    // {
    //   name: "",
    //   platform: "",
    //   timeperiod: '',
    //   description: '',
    //   url: ""
    // },
    // {
    //   name: "",
    //   platform: "",
    //   timeperiod: '',
    //   description: '',
    //   url: ""
    // },
    // {
    //   name: "",
    //   platform: "",
    //   timeperiod: '',
    //   description: '',
    //   url: ""
    // },
    // {
    //   name: "",
    //   platform: "",
    //   timeperiod: '',
    //   description: '',
    //   url: ""
    // },
    // {
    //   name: "",
    //   platform: "",
    //   timeperiod: '',
    //   description: '',
    //   url: ""
    // },
    // {
    //   name: "",
    //   platform: "",
    //   timeperiod: '',
    //   description: '',
    //   url: ""
    // },
    // {
    //   name: "",
    //   platform: "",
    //   timeperiod: '',
    //   description: '',
    //   url: ""
    // },
    // {
    //   name: "",
    //   platform: "",
    //   timeperiod: '',
    //   description: '',
    //   url: ""
    // },
    // {
    //   name: "",
    //   platform: "",
    //   timeperiod: '',
    //   description: '',
    //   url: ""
    // },
];

export const hobbies = [
    // {
    //   name: "Video Games",
    //   iconClass: "",
    //   iconClassFontAwesome: "fa fa-gamepad",
    //   url: "https://example.com"
    // },
    // {
    //   name: "Drawing",
    //   iconClass: "",
    //   iconClassFontAwesome: "fa fa-pencil",
    //   url: ""
    // },
    {
        name: "Getting out of the Safe Zone",
        iconClass: "",
        iconFontAwesome: {name: 'bullseye', icon: 'fa-bullseye', type: 'fas', fullname: 'fas fa-bullseye'},
        url: "",

    },
    {
        name: "Challenges",
        iconClass: "",
        iconFontAwesome: {name: 'biohazard', icon: 'fa-biohazard', type: 'fas', fullname: 'fas fa-biohazard'},
        url: "",
    },
    {
        name: "Cycling",
        iconClass: "",
        iconFontAwesome: {name: 'biking', icon: 'fa-biking', type: 'fas', fullname: 'fas fa-biking'},
        url: "",
    },
    {
        name: "Nature",
        iconClass: "",
        iconFontAwesome: {name: 'mountain', icon: 'fa-mountain', type: 'fas', fullname: 'fas fa-mountain'},
        url: "",
    },
    {
        name: "Challenges",
        iconClass: "",
        iconFontAwesome: {name: 'biohazard', icon: 'fa-biohazard', type: 'fas', fullname: 'fas fa-biohazard'},
        url: "",
    },
    {
        name: "Skiing",
        iconClass: "",
        iconFontAwesome: {name: 'skiing', icon: 'fa-skiing', type: 'fas', fullname: 'fas fa-skiing'},
        url: "",
    },
    {
        name: "Hacking Stuff",
        iconClass: "",
        iconFontAwesome: {name: 'magic', icon: 'fa-magic', type: 'fas', fullname: 'fas fa-magic'},
        url: "",
    },
    {
        name: "Teaching",
        iconClass: "",
        iconFontAwesome: {
            name: 'chalkboard-teacher',
            icon: 'fa-chalkboard-teacher',
            type: 'fas',
            fullname: 'fas fa-chalkboard-teacher'
        },
        url: "",
    },
    {
        name: "Leadership",
        iconClass: "",
        iconFontAwesome: {name: 'users', icon: 'fa-users', type: 'fas', fullname: 'fas fa-users'},
        url: "",
    },
    {
        name: "Music",
        iconClass: "",
        iconFontAwesome: {name: 'music', icon: 'fa-music', type: 'fas', fullname: 'fas fa-music'},
        url: "",
    },
    {
        name: "Books",
        iconClass: "",
        iconFontAwesome: {name: 'book-open', icon: 'fa-book-open', type: 'fas', fullname: 'fas fa-book-open'},
        url: "",
    },
    {
        name: "Making Bugs!",
        iconClass: "",
        iconFontAwesome: {name: 'bug', icon: 'fa-bug', type: 'fas', fullname: 'fas fa-bug'},
        url: "",
    },
    {
        name: "Coding",
        iconClass: "",
        iconFontAwesome: {name: 'code', icon: 'fa-code', type: 'fas', fullname: 'fas fa-code'},
        url: "",
    },


];

export const contributions = [
    {
        name: "best-resume-ever",
        description: "👔 💼 Build fast 🚀 and easy multiple beautiful resumes.",
        url: "https://github.com/salomonelli/best-resume-ever"
    },
    // {
    //   name: "",
    //   description: "",
    //   url: ""
    // },
    // {
    //   name: "",
    //   description: "",
    //   url: ""
    // },
    // {
    //   name: "",
    //   description: "",
    //   url: ""
    // },
    // {
    //   name: "",
    //   description: "",
    //   url: ""
    // },
    // {
    //   name: "",
    //   description: "",
    //   url: ""
    // },
    // {
    //   name: "",
    //   description: "",
    //   url: ""
    // },
    // {
    //   name: "",
    //   description: "",
    //   url: ""
    // },
    // {
    //   name: "",
    //   description: "",
    //   url: ""
    // },
];

export const fontAwesomeIconsBrands = [
    {name: 'node-js', icon: 'fa-node-js', type: 'fab', fullname: 'fab fa-node-js'},
    {name: 'node', icon: 'fa-node', type: 'fab', fullname: 'fab fa-node'},
    {name: 'linkedin-in', icon: 'fa-linkedin-in', type: 'fab', fullname: 'fab fa-linkedin-in'},
    {name: 'linkedin', icon: 'fa-linkedin', type: 'fab', fullname: 'fab fa-linkedin'},
    {name: 'js-square', icon: 'fa-js-square', type: 'fab', fullname: 'fab fa-js-square'},
    {name: 'js', icon: 'fa-js', type: 'fab', fullname: 'fab fa-js'},
    {name: 'jira', icon: 'fa-jira', type: 'fab', fullname: 'fab fa-jira'},
    {name: 'jenkins', icon: 'fa-jenkins', type: 'fab', fullname: 'fab fa-jenkins'},
    {name: 'java', icon: 'fa-java', type: 'fab', fullname: 'fab fa-java'},
    {name: 'instagram-square', icon: 'fa-instagram-square', type: 'fab', fullname: 'fab fa-instagram-square'},
    {name: 'instagram', icon: 'fa-instagram', type: 'fab', fullname: 'fab fa-instagram'},
    {name: 'html5', icon: 'fa-html5', type: 'fab', fullname: 'fab fa-html5'},
    {name: 'gitlab', icon: 'fa-gitlab', type: 'fab', fullname: 'fab fa-gitlab'},
    {name: 'github-square', icon: 'fa-github-square', type: 'fab', fullname: 'fab fa-github-square'},
    {name: 'github-alt', icon: 'fa-github-alt', type: 'fab', fullname: 'fab fa-github-alt'},
    {name: 'github', icon: 'fa-github', type: 'fab', fullname: 'fab fa-github'},
    {name: 'git-square', icon: 'fa-git-square', type: 'fab', fullname: 'fab fa-git-square'},
    {name: 'git-alt', icon: 'fa-git-alt', type: 'fab', fullname: 'fab fa-git-alt'},
    {name: 'git', icon: 'fa-git', type: 'fab', fullname: 'fab fa-git'},
    {name: 'facebook-square', icon: 'fa-facebook-square', type: 'fab', fullname: 'fab fa-facebook-square'},
    {name: 'facebook-f', icon: 'fa-facebook-f', type: 'fab', fullname: 'fab fa-facebook-f'},
    {name: 'facebook', icon: 'fa-facebook', type: 'fab', fullname: 'fab fa-facebook'},
    {name: 'edge', icon: 'fa-edge', type: 'fab', fullname: 'fab fa-edge'},
    {name: 'dropbox', icon: 'fa-dropbox', type: 'fab', fullname: 'fab fa-dropbox'},
    {name: 'docker', icon: 'fa-docker', type: 'fab', fullname: 'fab fa-docker'},
    {name: 'dev', icon: 'fa-dev', type: 'fab', fullname: 'fab fa-dev'},
    {name: 'css3-alt', icon: 'fa-css3-alt', type: 'fab', fullname: 'fab fa-css3-alt'},
    {name: 'css3', icon: 'fa-css3', type: 'fab', fullname: 'fab fa-css3'},
    {name: 'codepen', icon: 'fa-codepen', type: 'fab', fullname: 'fab fa-codepen'},
    {name: 'chrome', icon: 'fa-chrome', type: 'fab', fullname: 'fab fa-chrome'},
    {name: 'chromecast', icon: 'fa-chromecast', type: 'fab', fullname: 'fab fa-chromecast'},
    {name: 'bootstrap', icon: 'fa-bootstrap', type: 'fab', fullname: 'fab fa-bootstrap'},
    {name: 'apple', icon: 'fa-apple', type: 'fab', fullname: 'fab fa-apple'},
    {name: 'android', icon: 'fa-android', type: 'fab', fullname: 'fab fa-android'},
    {name: 'angular', icon: 'fa-angular', type: 'fab', fullname: 'fab fa-angular'},
    {name: 'reddit', icon: 'fa-reddit', type: 'fab', fullname: 'fab fa-reddit'},
    {name: 'python', icon: 'fa-python', type: 'fab', fullname: 'fab fa-python'},
    {name: 'waze', icon: 'fa-waze', type: 'fab', fullname: 'fab fa-waze'},
    {name: 'ubuntu', icon: 'fa-ubuntu', type: 'fab', fullname: 'fab fa-ubuntu'},
    {name: 'leanpub', icon: 'fa-leanpub', type: 'fab', fullname: 'fab fa-leanpub'},
    {name: 'linux', icon: 'fa-linux', type: 'fab', fullname: 'fab fa-linux'},
    {name: 'markdown', icon: 'fa-markdown', type: 'fab', fullname: 'fab fa-markdown'},
    {name: 'mdb', icon: 'fa-mdb', type: 'fab', fullname: 'fab fa-mdb'},
    {name: 'windows', icon: 'fa-windows', type: 'fab', fullname: 'fab fa-windows'},
    {name: 'microsoft', icon: 'fa-microsoft', type: 'fab', fullname: 'fab fa-microsoft'},
    {name: 'npm', icon: 'fa-npm', type: 'fab', fullname: 'fab fa-npm'},
    {name: 'php', icon: 'fa-php', type: 'php', fullname: 'fab fa-php'},
    {name: 'playstation', icon: 'fa-playstation', type: 'fab', fullname: 'fab fa-playstation'},
    {name: 'react', icon: 'fa-react', type: 'fab', fullname: 'fab fa-react'},
    {name: 'sass', icon: 'fa-sass', type: 'fab', fullname: 'fab fa-sass'},
    {name: 'skype', icon: 'fa-skype', type: 'fab', fullname: 'fab fa-skype'},
    {name: 'yarn', icon: 'fa-yarn', type: 'fab', fullname: 'fab fa-yarn'},
    {name: 'spotify', icon: 'fa-spotify', type: 'fab', fullname: 'fab fa-spotify'},
    {name: 'strava', icon: 'fa-strava', type: 'fab', fullname: 'fab fa-strava'},
    {name: 'stack-overflow', icon: 'fa-stack-overflow', type: 'fab', fullname: 'fab fa-stack-overflow'}
];

export default {
    images,
    person,
    socials,
    experiences,
    education,
    skills,
    knowledge,
    projects,
    hobbies,
    contributions,

}
